import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';

// material-ui components
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';

// @@material-ui/core/icons
import Person from '@material-ui/icons/Person';
import PowerSettingsNew from '@material-ui/icons/PowerSettingsNew';
import Dashboard from '@material-ui/icons/Dashboard';

import { headerLinksStyle } from './styles.jsx';

class HeaderLinks extends React.Component {
    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    render() {
        const { classes, logout } = this.props;

        return (
            <div>
                <NavLink
                    to="/"
                    className={ classes.itemLink }
                >
                    <IconButton
                        color="inherit"
                        className={ classes.buttonLink }
                    >
                        <Dashboard className={ classes.links }/>
                        <Hidden mdUp>
                            <p className={ classes.linkText }>
                                <FormattedMessage id="menu.dashboard"/>
                            </p>
                        </Hidden>
                    </IconButton>
                </NavLink>
                <NavLink
                    to="/profile"
                    className={ classes.itemLink }
                >
                    <IconButton
                        color="inherit"
                        className={ classes.buttonLink }
                    >
                        <Person className={ classes.links }/>
                        <Hidden mdUp>
                            <p className={ classes.linkText }>
                                <FormattedMessage id="menu.profile"/>
                            </p>
                        </Hidden>
                    </IconButton>
                </NavLink>
                <a
                    href="#"
                    onClick={ logout }
                    className={ classes.itemLink }
                >
                    <IconButton
                        color="inherit"
                        className={ classes.buttonLink }
                    >
                        <PowerSettingsNew className={ classes.links }/>
                        <Hidden mdUp>
                            <p className={ classes.linkText }>
                                <FormattedMessage id="button.logout"/>
                            </p>
                        </Hidden>
                    </IconButton>
                </a>
            </div>
        );
    }
}

HeaderLinks.propTypes = {
    classes: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
};

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/common/Header/HeaderLinks.jsx